<mat-card class="trial-ended-banner">
  <mat-card-content>
    <div class="row row-gutters">
      <div class="col col-xs-12 col-sm-2 image">
        <img src="{{ 'images/trial-ended-banner/trial-ended.png' | getImageSrc }}" />
      </div>
      <div class="col">
        <mat-card-title>
          {{ 'TRIAL_ENDED_BANNER.HEADING' | translate }}
        </mat-card-title>
        <p>
          {{ 'TRIAL_ENDED_BANNER.DESCRIPTION' | translate }}
        </p>
        <button (click)="redirectToUpgradePage()" mat-flat-button color="primary">
          {{ 'START_TRIAL_MODAL.COMPARE_PLANS' | translate }}
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
